import { TabQueryState } from '@/components/layout/query-state';
import { TAB_BOTTOM_SPACING, TabScreenWrapper } from '@/components/layout/tab-screen-wrapper';
import { PageTitle } from '@/components/seo/page-title';
import { ProfileScreen } from '@/features/profile/profile-screen';
import { FRIENDS_QUERY_KEYS } from '@/api/queries/friendship';
import { FEED_QUERY_KEYS } from '@/features/activity/hooks/use-activity';
import { useCurrentUserProfile } from '@/hooks/use-profile';
import { getErrorMessage } from '@/utils/format-error';
import { useQueryClient } from '@tanstack/react-query';
import React, { useCallback } from 'react';
import { RefreshControl, ScrollView } from 'react-native';

export default function ProfileView() {
  const queryClient = useQueryClient();

  const {
    data: profileData,
    isLoading: loading,
    error,
    refetch: refetchProfile,
    isRefetching,
  } = useCurrentUserProfile();

  const onRefresh = useCallback(() => {
    refetchProfile();
    queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.all });
    queryClient.invalidateQueries({ queryKey: FRIENDS_QUERY_KEYS.all });
  }, [refetchProfile, queryClient]);

  return (
    <TabQueryState
      isLoading={loading}
      error={error}
      onRetry={() => refetchProfile()}
      loadingMessage="Loading profile..."
      errorMessage={getErrorMessage(error) ?? undefined}
    >
      <PageTitle title="Profile" />
      {profileData?.user ? (
        <TabScreenWrapper>
          <ScrollView
            showsVerticalScrollIndicator={false}
            className="flex-1"
            contentContainerStyle={{ paddingBottom: TAB_BOTTOM_SPACING }}
            refreshControl={
              <RefreshControl
                refreshing={isRefetching}
                onRefresh={onRefresh}
              />
            }
          >
            <ProfileScreen user={profileData.user} isCurrentUser={true} />
          </ScrollView>
        </TabScreenWrapper>
      ) : null}
    </TabQueryState>
  );
}
